import { LoyaltyRewards } from 'pages/loyalty/loyalty-rewards';
import { useFlag } from 'utils/launchdarkly';

const LoyaltyRewardsListWidget = () => {
  const enableRewardPageStandAlone = useFlag('enable-reward-page-stand-alone');

  return <LoyaltyRewards isWidget={!enableRewardPageStandAlone} />;
};

export default LoyaltyRewardsListWidget;
